import React from "react";

const CompanyName = ({ row }) => {
  return <div>{row?.company?.companyName}</div>;
};

export default CompanyName;
